function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  opacity: 0.2,
  cx: 50,
  cy: 50,
  r: 50,
  fill: "#15A9E1"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M49.9982 76L74.7389 75.9693C78.0522 75.9661 79.8828 73.5757 79.8828 71.0557V39.3913C79.8828 37.4 78.2536 35.7699 76.2628 35.7699H23.734C21.7432 35.7699 20.1172 37.4 20.1172 39.3913V71.0557C20.1172 73.5757 21.9441 75.9661 25.2611 75.9693L49.9982 76Z",
  fill: "#8EBFE8"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M75.3156 34.8763V68.9861H49.9985V33.3286C50.2608 33.1771 50.563 33.0288 50.9067 32.8869C53.1324 31.965 57.0829 31.2669 62.9102 31.1021C67.4233 31.2275 70.0005 31.5653 72.4344 32.2575C74.5855 32.8677 75.3156 33.0627 75.3156 34.8763Z",
  fill: "#ECEFF1"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M53.5294 49.3517L50.9069 63.9375L49.9987 68.9861H24.6843V34.8763C24.6843 33.0627 25.4145 32.8677 27.5618 32.2575C29.9994 31.5653 32.573 31.2271 37.0897 31.1021C42.9161 31.2669 46.8639 31.9636 49.0895 32.8855C49.4338 33.0288 49.7368 33.1767 49.9987 33.3286L50.9069 37.449L53.5294 49.3517Z",
  fill: "#ECEFF1"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.5562 71.4068H49.9982L51.3994 70.0056L49.9982 68.9857C46.0102 66.6703 32.6343 65.3304 24.6848 68.9857V69.4837C24.6848 70.5407 25.5271 71.4068 26.5562 71.4068Z",
  fill: "#90A4AE"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M75.3151 68.9857C67.3624 65.3304 53.9897 66.6703 49.998 68.9857V71.4068H73.4401C74.4696 71.4068 75.3147 70.5407 75.3147 69.4837V68.9857H75.3151Z",
  fill: "#90A4AE"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M59.103 41.2086L61.9393 42.8931L64.7784 41.2086H64.9967C64.9967 36.2917 69.7552 35.6573 69.7488 30.3687C69.7419 25.3288 65.8422 22.8495 61.9393 22.9076C58.0396 22.8495 54.1399 25.3288 54.1331 30.3687C54.1262 35.6573 58.8847 36.2917 58.8847 41.2086H59.103Z",
  fill: "#FCD968"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M66.7999 30.3687C66.8068 35.6573 62.0483 36.2917 62.0483 41.2086H64.9968C64.9968 36.2917 69.7552 35.6573 69.7484 30.3687C69.742 25.3288 65.8423 22.8495 61.9389 22.9076C61.4482 22.8976 60.9538 22.9315 60.4663 23.0065C63.8208 23.5215 66.7967 25.9696 66.7999 30.3687Z",
  fill: "#E6A235"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M71.719 35.7699V67.7378C72.9939 68.0651 74.2069 68.4744 75.3152 68.9857V34.8763C75.3152 33.0622 74.5855 32.8681 72.4345 32.2575C72.1996 32.1893 71.9607 32.1247 71.719 32.0634V35.7699Z",
  fill: "#C4CCCF"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M75.3152 68.9857C74.2069 68.4744 72.9939 68.0651 71.719 67.7378V71.4068H73.4402C74.4697 71.4068 75.3147 70.5407 75.3147 69.4837V68.9857H75.3152Z",
  fill: "#7C8C94"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M75.3152 69.4837C75.3152 70.5407 74.4697 71.4068 73.4402 71.4068H71.719V75.9725L74.7389 75.9693C78.0522 75.9661 79.8828 73.5757 79.8828 71.0557V39.3913C79.8828 37.4 78.2536 35.7699 76.2628 35.7699H75.3152V69.4837Z",
  fill: "#519AD6"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M29.3453 54.2782C29.0016 54.2782 28.6724 54.0818 28.5191 53.7486C28.309 53.2922 28.509 52.752 28.9649 52.5419C32.1295 51.0853 36.1028 50.9892 38.1893 51.0615C41.3191 51.17 44.1499 51.7527 45.5767 52.5817C46.0111 52.8339 46.1585 53.3906 45.9063 53.825C45.6545 54.2599 45.0984 54.4073 44.6639 54.1551C42.4745 52.8829 34.4787 52.0072 29.7244 54.1949C29.6017 54.2516 29.4726 54.2782 29.3453 54.2782Z",
  fill: "#37474F"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M29.3453 60.9547C29.0016 60.9547 28.6724 60.7583 28.5191 60.425C28.309 59.9687 28.509 59.4285 28.9649 59.2184C32.1295 57.7618 36.1028 57.6656 38.1893 57.738C41.3191 57.8469 44.1499 58.4292 45.5767 59.2582C46.0111 59.5104 46.1585 60.0671 45.9063 60.5015C45.6545 60.9364 45.0984 61.0838 44.6639 60.8315C42.4745 59.5599 34.4787 58.6833 29.7244 60.8714C29.6017 60.9281 29.4726 60.9547 29.3453 60.9547Z",
  fill: "#37474F"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M29.3452 47.6017C29.0014 47.6017 28.6723 47.4053 28.5189 47.0721C28.3088 46.6162 28.5084 46.0755 28.9643 45.8654C32.1284 44.407 36.1022 44.3109 38.1896 44.3836C41.3184 44.4926 44.1488 45.0753 45.5766 45.9048C46.011 46.157 46.1584 46.7141 45.9062 47.1485C45.6544 47.583 45.0982 47.7304 44.6638 47.4786C42.4725 46.2051 34.4753 45.328 29.7247 47.518C29.6015 47.5747 29.4724 47.6017 29.3452 47.6017Z",
  fill: "#37474F"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M70.6511 54.2782C70.5243 54.2782 70.3947 54.2517 70.2716 54.1949C65.5177 52.005 57.5247 52.882 55.3361 54.1551C54.9026 54.4073 54.346 54.2604 54.0938 53.8255C53.8415 53.3915 53.9885 52.8344 54.4229 52.5817C55.8479 51.7527 58.6783 51.17 61.8089 51.0615C63.8954 50.9887 67.8693 51.0858 71.0319 52.5419C71.4879 52.752 71.6875 53.2922 71.4773 53.7486C71.3245 54.0818 70.9953 54.2782 70.6511 54.2782Z",
  fill: "#37474F"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M70.6511 60.9547C70.5243 60.9547 70.3947 60.9281 70.2716 60.8714C65.5177 58.6814 57.5247 59.5585 55.3361 60.8315C54.9026 61.0838 54.346 60.9368 54.0938 60.5024C53.8415 60.068 53.9885 59.5114 54.4229 59.2587C55.8479 58.4292 58.6783 57.8465 61.8089 57.738C63.8954 57.6657 67.8693 57.7622 71.0319 59.2184C71.4879 59.4285 71.6875 59.9687 71.4773 60.4255C71.3245 60.7583 70.9953 60.9547 70.6511 60.9547Z",
  fill: "#37474F"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M50.9069 32.8869V68.9861C50.9069 69.4879 50.5004 69.8962 49.9987 69.8962C49.4961 69.8962 49.0896 69.4883 49.0896 68.9861V32.8855C49.4334 33.0288 49.7369 33.1767 49.9987 33.3286C50.261 33.1771 50.5627 33.0288 50.9069 32.8869Z",
  fill: "#90A4AE"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M64.274 32.1765H59.5124C59.0102 32.1765 58.6033 32.5839 58.6033 33.0865C58.6033 33.5887 59.0102 33.9961 59.5124 33.9961H61.0303V41.2086C61.0303 41.7108 61.4373 42.1182 61.9395 42.1182C62.4412 42.1182 62.8481 41.7108 62.8481 41.2086V33.9961H64.274C64.7762 33.9961 65.1832 33.5887 65.1832 33.0865C65.1832 32.5839 64.7762 32.1765 64.274 32.1765Z",
  fill: "#ECEFF1"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M61.9458 20.2064C61.4441 20.2064 61.0371 19.799 61.0371 19.2968V16.9096C61.0371 16.4074 61.4441 16 61.9458 16C62.4479 16 62.8549 16.4074 62.8549 16.9096V19.2968C62.8549 19.799 62.4479 20.2064 61.9458 20.2064Z",
  fill: "#FCD968"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M54.2115 22.3341C53.979 22.3341 53.7464 22.2453 53.5688 22.0677L51.8783 20.3767C51.5231 20.0215 51.5231 19.4451 51.8778 19.0899C52.2331 18.7347 52.8085 18.7347 53.1632 19.0894L54.8542 20.7809C55.2094 21.1361 55.2094 21.712 54.8547 22.0677C54.6771 22.2453 54.4445 22.3341 54.2115 22.3341Z",
  fill: "#FCD968"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M69.6807 22.3341C69.4482 22.3341 69.2156 22.2457 69.0385 22.0681C68.6833 21.7133 68.6828 21.137 69.0371 20.7818L70.7244 19.0904C71.0792 18.7347 71.6546 18.7342 72.0098 19.089C72.3651 19.4442 72.3655 20.0201 72.0112 20.3758L70.3239 22.0672C70.1463 22.2453 69.9133 22.3341 69.6807 22.3341Z",
  fill: "#FCD968"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M29.3453 40.9216C29.0016 40.9216 28.6724 40.7252 28.5191 40.3919C28.309 39.9355 28.509 39.3954 28.9649 39.1853C32.1285 37.7291 36.1028 37.6339 38.1898 37.7062C41.3177 37.8152 44.148 38.397 45.5758 39.2246C46.0102 39.4764 46.1585 40.0331 45.9068 40.4675C45.6555 40.9028 45.0988 41.0507 44.6649 40.7989C42.4722 39.5281 34.4737 38.6524 29.7244 40.8383C29.6017 40.895 29.4726 40.9216 29.3453 40.9216Z",
  fill: "#37474F"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M61.9394 41.2086H59.1031C57.8727 41.2086 56.8706 42.2148 56.8706 43.442C56.8706 44.6697 57.8727 45.6722 59.1031 45.6722H64.7789C66.0062 45.6722 67.0114 44.6697 67.0114 43.442C67.0114 42.2148 66.0062 41.2086 64.7789 41.2086H61.9394Z",
  fill: "#C4CCCF"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M67.0115 43.442C67.0115 42.2148 66.0058 41.2086 64.7785 41.2086H61.8301C62.4948 41.2086 63.0949 41.502 63.5037 41.9657C63.8516 42.3612 64.063 42.8762 64.063 43.442C64.063 44.6697 63.0605 45.6722 61.8301 45.6722H64.7785C66.0058 45.6722 67.0115 44.6697 67.0115 43.442Z",
  fill: "#90A4AE"
});

var SvgKnowledgeBank = function SvgKnowledgeBank(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKnowledgeBank, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/knowledge-bank.d6453da5.svg";
export { ForwardRef as ReactComponent };